import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InpageDraggableLayout from '../sections/InpageDraggableLayout';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import MobileSidebarOverlayContainer from 'ContentEditorUI/components/sidebar/MobileSidebarOverlayContainer';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InpageLayoutsContainer = ({
  onDragStart,
  onDragEnd,
  sidebarSearchResultsMap
}) => {
  const dispatch = useDispatch();
  const closePatagoniaSidebarCallback = useCallback(() => {
    dispatch(closePatagoniaSidebar());
  }, [dispatch]);
  const categorizedSearchQuery = useSelector(getSidebarSearchQuery);
  const filteredCollection = sidebarSearchResultsMap['LAYOUTS'].results;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MobileSidebarOverlayContainer, {
      modalMessageKey: "addModule.mobile.message.addLayout",
      contextual: false
    }), !sidebarSearchResultsMap['LAYOUTS'].count && /*#__PURE__*/_jsx(View, {
      margin: "500",
      as: "div",
      children: /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
        title: 'addSectionPanel.columnLayouts.noLayoutsTitle',
        searchQuery: categorizedSearchQuery
      })
    }), !!sidebarSearchResultsMap['LAYOUTS'].count && /*#__PURE__*/_jsx(Flex, {
      flexWrap: "wrap",
      justifyContent: "center",
      marginBlockStart: "500",
      children: Object.keys(filteredCollection).map(layoutKey => {
        const layoutSection = filteredCollection[layoutKey];
        return /*#__PURE__*/_jsx(InpageDraggableLayout, {
          widths: layoutSection.widths,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          labelKey: layoutKey,
          iconHeight: 35,
          closePatagoniaSidebar: closePatagoniaSidebarCallback
        }, `defaultSection-${layoutKey}`);
      })
    })]
  });
};
export default InpageLayoutsContainer;